import { useRef, useState, useEffect, useCallback } from 'react'
import Axios from 'axios'
import styled from 'styled-components'
import DefaultUserImg from './assets/img/default-user-image.svg'

import { DateTime } from 'luxon'

import './assets/css/app.css'
import './assets/css/loading-spinner.css'
import CreateAccountPage from './pages/CreateAccountPage'
import Articles from './components/Articles'

import iconArrowUp from './assets/icon/arrow-up.png'
import iconArrowDown from './assets/icon/arrow-down.png'
import iconVisa from './assets/icon/visa.svg'

import { ADMIN_CREDENTIALS } from './utils/constants'
import { resolveAssetPath } from './utils/assetPath'
import AdminLoginModal from './components/Admin/AdminLoginModal'
import AdminSettingsPage from './pages/AdminSettingsPage'
import bannerAccountCreated from './assets/img/banner-account-created.png'
import bannerInternalError from './assets/img/banner-internal-error.png'
import bannerDownloadSuccessful from './assets/img/banner-download-successful.png'
import iconBoxedAvatar from './assets/icon/boxed-avatar.png'
import iconCirclePlus from './assets/icon/circle-plus.png'
import Header from './components/Header/Header'

import {
  FormContainer,
  FormWrapper,
  Icon,
  QR,
} from './styled/CommonStylesForms'
import BannerText from './components/BannerText'
import PlanAndBook from './components/PlanAndBook'

// const SeamlessRadioInput = styled.input`
//   appearance: none;
//   -webkit-appearance: none;
//   border-radius: 0;
//   border: 1px solid #ffffff;
//   box-shadow: 0px 0px 0px 1px #aaaaaa;
//   height: 10px;
//   width: 10px;
//   accent-color: #aaaaaa;

//   input:checked {
//     background-color: #aaaaaa;
//   }
// `

const SpinnerText = styled.h3`
  font-weight: 600;
  font-size: 11px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #0069b4;
`

const SeamlessRadioInputCheckmark = styled.span`
  display: inline-block;  
  position: absolute:
  top: 0;
  left: 0;
  height: 10px;
  width: 10px;
  box-shadow: 0 0 0 1px #aaaaaa;
  margin: 5px;
  vertical-align: bottom;
`

const SeamlessRadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;

  &:checked + ${SeamlessRadioInputCheckmark} {
    background-color: #aaaaaa;
  }
`

const SeamlessRadioContainer = styled.label`
  display: block;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;

  &:hover ${SeamlessRadioInputCheckmark} {
    background-color: #000000;
  }
`

const CircledPlusIcon = styled.img``

const CircleButtonHelper = styled.div`
  display: flex
  justify-content: center
  align-items: center
  margin-bottom: 25px;
  height: 85px;
  border-radius: 7px;
  background: #00000059;
  box-shadow: 0px 0px 2px 0px #000000;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}
`

const DashboardWelcomeWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const DashboardWelcomeContainer = styled.div`
  display: flex;
  color: #ffffff;
  padding: 20px;
  alight-items: center;
  justify-content: space-between;
  width: 1100px;
  margin-top: 40px;
  margin-bottom: 80px;
`

const DashboardWelcomeLeftContainer = styled.div``

const DashboardWelcomeHeaderText = styled.h1`
  font-family: 'RobotoMono', monospace;
  text-transform: uppercase;
`

const DashboardWelcomeMiddleContainer = styled.div``

const DashboardWelcomeRightContainer = styled.div``
const DashboardWelcomeFlexContainer = styled.div`
  display: flex;
  gap: 20px;
  padding-right: 20px;
`

const DashboardWelcomeLabelText = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  margin-bottom: 10px;
`

const DashboardWelcomeValueText = styled.p`
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
`

const BoxedAvatarIcon = styled.img`
  width: 13px;
  height: 15px;
  vertical-align: middle;
`
const DashboardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 50px;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: 50px;
    padding: 20px 13px;
    width: 100%;
  }

  @media (max-width: 720px) {
      flex-direction: column;
  }
  justify-content: center;
`

const BoardingPassButton = styled.button`
  background-color: #4c3de3;
  color: #ffffff;
  padding: 10px 20px;

  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;

  height: 28;
  border-radius: 18.5px;
  border-width: 0px;
  border-radius: 22px;
  :hover {
    cursor: pointer;
  }
`

const EditButton = styled.button`
  color: #000000;
  background-color: transparent;
  padding: 10px 20px;

  height: 28;
  border-radius: 18.5px;
  border-width: 1px;

  border: solid;
  border-width: 1px;
  border-radius: 22px;

  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
`

const CancelTripButton = styled.button`
  color: #000000;
  background-color: transparent;
  padding: 10px 20px;

  height: 28;
  border-radius: 18.5px;
  border-width: 1px;

  border: solid;
  border-width: 1px;
  border-radius: 22px;
  color: #000000;
  background-color: transparent;

  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
`

const TripsCard = styled.div`
  class: trips-banner;
  display: flex;
  margin-bottom: 5px;
  color: #fff;
  border-radius: 7px;
  height: 138px;
}
`
const TripsImageContainer = styled.div`
  position: relative;
`

const IconVisa = styled.img`
  width: 13px;
  margin-right: 5px;
`

const BackgroundGradient = styled.div`
  position: absolute;
  top: 0;
  left 0;
  background:  linear-gradient(90deg, #000000 0%, transparent 100%);
  height: 100%;
  border-radius: 10px;
  width: 100%;
  opacity: 50%;
`

const TripsTextContainter = styled.div`
  margin-left: 5px;
  background-color: #ffffff;
  border-radius: 10px;
  width: 100%;
  gap: 10px;
  padding: 10px 30px;
`

const TripsRow1And2 = styled.div`
  display: inline-grid;
  grid-template-columns: 35% 35% 30%;
  column-gap: 20px;
  row-gap: 10px;
  color: #000000;
  margin-bottom: 10px;
`

const TripsRow3 = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 3px;
`

const TripsRow4 = styled.div`
  display: flex;
  color: #000000;
  align-items: center;
`

const TripItemWrapper = styled.div`
  display: flex;
  gap: 10px;
  position: relative;
`

const TripsLabelText = styled.p`
  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  height: 100%;
  color: #000000;
  margin: 0;
  margin-top: 5px;
  bottom: 0px;
  left: 0px;
  vertical-align: bottom;
`
const TripsValueText = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  height: 100%;
  color: #000000;
  margin: 0;
`

const Frame = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`

const AdminPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const QrCodeTitleText = styled.h1`
  font-weight: 300;
  font-size: 53px;
  line-height: 60px;
  letter-spacing: -5%;
  text-align: center;
  vertical-align: middle;
`

const QrCodeSmallText = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffff;
`

const QrCodeInstructionsText = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #ef7d00;
`

const QrCodeInstructionsSubText = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  margin: 20px;
`

const QrCodeButton = styled.button`
  padding: 0 40px;
  height: 44px;

  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;

  border: solid;
  border-width: 1px;
  border-radius: 22px;
  border-color: #4c3de3;
  background-color: #ffffff;
  color: #4c3de3;
  margin: 20px;

  :hover {
    cursor: pointer;
  }
`

const QrCodeButtonSubText = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
`

const SuccessPageContainer = styled.div`
  background-image: url(${bannerAccountCreated});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
`

const SuccessContentCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
`

const SuccessMainText = styled.h1`
  font-family: 'RobotoMono', monospace;
  font-weight: 300;
  font-size: 53px;
  line-height: 60px;
  letter-spacing: -5%;
  text-align: center;
  vertical-align: middle;
  color: #ffffff;
  margin-bottom: 20px;
`

const SuccessRedirectingText = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffff;
  margin-bottom: 40px;
`

const ErrorPageContainer = styled.div`
  background-image: url(${bannerInternalError});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
`

const ErrorContentCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
`

const ErrorMainText = styled.h1`
  font-family: 'RobotoMono', monospace;
  font-weight: 300;
  font-size: 53px;
  line-height: 60px;
  letter-spacing: -5%;
  text-align: center;
  vertical-align: middle;
  color: #ffffff;
  margin-bottom: 20px;
`

const ErrorSubText = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffff;
  margin-bottom: 40px;
`

const ErrorReturnButton = styled.button`
  padding: 0 40px;
  height: 44px;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  border: none;
  border-radius: 22px;
  background-color: #4c3de3;
  color: #ffffff;
  cursor: pointer;

  :hover {
    opacity: 0.9;
  }
`

const DownloadSuccessPageContainer = styled.div`
  background-image: url(${bannerDownloadSuccessful});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
`

const DownloadSuccessContentCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
`

const DownloadSuccessMainText = styled.h1`
  font-family: 'RobotoMono', monospace;
  font-weight: 300;
  font-size: 53px;
  line-height: 60px;
  letter-spacing: -5%;
  text-align: center;
  vertical-align: middle;
  color: #ffffff;
  margin-bottom: 20px;
`

const DownloadSuccessSubText = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffff;
  margin-bottom: 40px;
`

const DownloadSuccessReturnButton = styled.button`
  padding: 0 40px;
  height: 44px;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  border: none;
  border-radius: 22px;
  background-color: #4c3de3;
  color: #ffffff;
  cursor: pointer;

  :hover {
    opacity: 0.9;
  }
`

const DeniedMessageBox = styled.div`
  background-color: #ff782d;
  color: #000;
  border: 1px solid black;
  padding: 20px;
  margin: 20px auto;
  text-align: center;
  font-size: 16px;
  width: 65%;
`

const BoardingPassReviewTitle = styled.h1`
  font-family: 'RobotoMono', monospace;
  font-weight: 300;
  font-size: 55px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #ffffff;
  margin-bottom: 16px;
`

const BoardingPassReviewSubtitle = styled.p`
  background-color: ${({ denied }) => (denied ? '#fff' : 'transparent')};
  color: ${({ denied }) => (denied ? '#d00' : '#ffffff')};
  padding: ${({ denied }) => (denied ? '110px 20px' : '0')};
  font-size: 36px;
  font-weight: ${({ denied }) => (denied ? 'normal' : 'bold')};
  text-align: ${({ denied }) => (denied ? 'center' : 'left')};
  border-radius: ${({ denied }) => (denied ? '10px' : '0')};
`

const BoardingPassCard = styled.div`
  background-color: #ffffff;
  color: #2b3d2b;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
  position: relative;
  margin: 30px 0;
  height: 330px;
  width: 94vw;
  max-width: 757px;
  text-transform: uppercase;
  border-radius: 7px;

  .boarding-pass-logo {
    color: #2b3d2b;
  }

  .pass-label,
  .pass-data {
    color: #2b3d2b;
  }
`

const DownloadButton = styled.button`
  background-color: #4c3de3;
  color: #ffffff;
  padding: 7px 20px;
  border: none;
  border-radius: 22px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;

  :hover {
    opacity: 0.9;
  }
`

/**
 * Render a destination background image if provided.
 * @param {{backgroundImage?: string}} props Component props containing raw or relative path.
 * @returns {JSX.Element|null}
 */
function Location({ backgroundImage }) {
  if (!backgroundImage) return null
  const src = resolveAssetPath(backgroundImage) || backgroundImage
  return <img className="location-image" src={src} alt="" />
}

/**
 * Animated main banner container cycling through background classes if banner flag set.
 * @param {{banner?: string, children: React.ReactNode}} props Props.
 * @returns {JSX.Element}
 */
function Main(props) {
  const [activeClass, setActiveClass] = useState('')

  let mainClasses = ['banner-plane-1', 'banner-plane-2', 'banner-plane-3']

  let count = 0
  useEffect(() => {
    if (props.banner === 'true') {
      setActiveClass(mainClasses[0])
      const interval = setInterval(() => {
        count++
        setActiveClass(mainClasses[count % mainClasses.length])
      }, 7000)
      return () => clearInterval(interval)
    } else {
      return
    }
  }, [])

  return <main className={activeClass}>{props.children}</main>
}

/**
 * Promise-based sleep utility for polling / sequencing effects.
 * @param {number} ms Milliseconds to wait.
 * @returns {Promise<void>}
 */
function sleep(ms) {
  return new Promise((resolveFunc) => setTimeout(resolveFunc, ms))
}

/**
 * Root application component controlling page state & credential workflows.
 * Manages: invitation lifecycle, connection polling, credential issuance, trip config, admin auth, boarding pass verification & issuance.
 * @param {object} props Currently unused external props.
 * @returns {JSX.Element}
 */
function App(props) {
  // Page State controls which screen is displayed on the site
  // Valid values:
  /*
    [
      home,
      create-account-form,
      create-account-issue,
      create-account-success,
      error-page,
      account-dashboard,
      boarding-pass-review,
      boarding-pass-success,
      admin-settings,
    ]
  */
  const [pageState, setPageState] = useState('home')
  // const [pageState, setPageState] = useState('account-dashboard')

  const [invitation, setInvitation] = useState({})
  const [connectionActive, setConnectionActive] = useState(false)
  const [connectionPurpose, setConnectionPurpose] = useState('')
  const effectRan = useRef()

  const [loader, setLoader] = useState(false)

  const [userData, setUserData] = useState({})
  const [digitalPassportData, setDigitalPassportData] = useState({})
  const [selectedTripData, setSelectedTripData] = useState()
  const [showLoginModal, setShowLoginModal] = useState(false)
  const [boardingDenied, setBoardingDenied] = useState(false)
  const [tripConfig, setTripConfig] = useState({
    trips: [],
    enabled_restrictions: false,
  })
  const [adminAuthenticated, setAdminAuthenticated] = useState(false)
  const [showAdminLoginModal, setShowAdminLoginModal] = useState(false)
  const [adminLoginError, setAdminLoginError] = useState('')

  const syncSelectedTrip = useCallback((updatedConfig, fallbackTrip) => {
    const trips = updatedConfig?.trips || []

    setSelectedTripData((previousSelection) => {
      if (previousSelection?.id) {
        const match = trips.find((trip) => trip.id === previousSelection.id)
        if (match) {
          return match
        }
      }

      if (fallbackTrip) {
        return fallbackTrip
      }

      return trips.length ? trips[0] : undefined
    })
  }, [])

  const requestInvitation = async () => {
    if (Object.keys(invitation).length === 0) {
      try {
        const res = await Axios({
          method: 'POST',
          url: `/api/invitations`,
        })
        console.log('Got invitation')
        console.log('Invitation:', res.data)
        setInvitation(res.data)
      } catch (error) {
        console.log('Error in requestInvitation:', error)
      }
    }
  }

  const refreshInvitation = useCallback(() => {
    setInvitation({})
    setConnectionActive(false)
    setLoader(false)
  }, [])

  useEffect(() => {
    //(AmmonBurgi) Prevent from triggering twice in development. See React strict mode.
    if (process.env.NODE_ENV === 'development') {
      if (effectRan.current === true) {
        requestInvitation()
      }

      return () => {
        effectRan.current = true
      }
    } else {
      requestInvitation()
    }
  }, [invitation])

  useEffect(() => {
    async function loadTripConfig() {
      try {
        const response = await Axios({
          method: 'GET',
          url: `/api/trip-config`,
        })
        if (response?.data) {
          setTripConfig(response.data)
          syncSelectedTrip(response.data)
        }
      } catch (error) {
        console.log('Error loading trip configuration:', error)
      }
    }

    loadTripConfig()
  }, [syncSelectedTrip])

  useEffect(() => {
    async function issueAccountCredential() {
      if (invitation.invitation_id && !connectionActive) {
        try {
          const res = await Axios({
            method: 'GET',
            url: `/api/connections/${invitation.invitation_id}`,
            timeout: 1000 * 60 * 63,
          })
          console.log('Connection confirmed!')
          console.log(res.data.connectionId)
          setInvitation({
            ...invitation,
            connection_id: res.data.connectionId,
          })
          setConnectionActive(true)
          setLoader(true)
        } catch (error) {
          console.log(
            'Error in issueAccountCredential (GET connection):',
            error
          )
        }
      }
      if (
        invitation.connection_id &&
        connectionActive &&
        connectionPurpose === 'login'
      ) {
        console.log('TRYING LOGIN')
        try {
          const verRes = await Axios({
            method: 'POST',
            url: `/api/verifications`,
            data: {
              connection_id: invitation.connection_id,
              contact_id: invitation.contact_id,
              invitation_id: invitation.invitation_id,
              workflow: 'Air_ID',
            },
            timeout: 1000 * 60 * 63,
            // signal: verController.signal,
          })
          const verificationRecords = verRes.data.verificationRecords

          //console.log('Verification:', verRes)

          let verifiedAttributes = {}
          verificationRecords.forEach((record) => {
            record.result_data.forEach((attributes, index) => {
              verifiedAttributes[attributes.name] = attributes.value
            })
          })

          // Now that we have the presentation, set the userData and do some housekeeping
          setUserData({
            accound_id: verifiedAttributes['account_id'],
            account_established_date:
              verifiedAttributes['account_established_date'],
            username: verifiedAttributes['username'],
            email: verifiedAttributes['email'],
            phone_number: verifiedAttributes['phone_number'],
            given_names: verifiedAttributes['given_names'],
            family_names: verifiedAttributes['family_names'],
            airline_name: verifiedAttributes['airline_name'],
            frequent_flyer_number: verifiedAttributes['frequent_flyer_number'],
            credential_issued_date:
              verifiedAttributes['credential_issued_date'],
          })

          setConnectionPurpose('')
          setShowLoginModal(false)
          setLoader(false)
          setPageState('account-dashboard')
        } catch (error) {
          console.log(
            'Error in issueAccountCredential (POST verifications for login):',
            error
          )
        }
      }
      if (
        invitation.connection_id &&
        connectionActive &&
        connectionPurpose === 'new-account'
      ) {
        // Issue an Air ID credential
        const accountID = parseInt(Math.random() * 1000000000, 10).toString()
        let accountEstablisheDate = Math.floor(Date.now() / 1000)
        accountEstablisheDate = accountEstablisheDate.toString()

        // Update the userData to include the new values
        setUserData({
          ...userData,
          accound_id: accountID,
          account_established_date: accountEstablisheDate,
          airline_name: 'SITA Air',
          frequent_flyer_number: accountID,
        })

        // Set up the credentialData for issuance
        const credentialData = {
          account_id: accountID,
          account_established_date: accountEstablisheDate,
          username: userData.username,
          email: userData.email,
          phone_number: userData.phone_number,
          given_names: userData.given_names,
          family_names: userData.family_names,
          country_of_citizenship: '',
          country_of_residence: '',
          airline_name: 'SITA Air',
          frequent_flyer_number: accountID,
          credential_issued_date: accountEstablisheDate,
        }
        try {
          await Axios({
            method: 'POST',
            url: `/api/credentials/`,
            data: {
              invitation_id: invitation.invitation_id,
              contact_id: '',
              schemaName: 'Air_ID',
              credentialData: credentialData,
            },
          })
          async function createAccountSuccess() {
            setLoader(false)
            setPageState('create-account-success')
            await sleep(5000)
            setPageState('account-dashboard')
          }
          createAccountSuccess()
        } catch (error) {
          console.log(
            'Error in issueAccountCredential (POST credentials for new account):',
            error
          )
          setPageState('error-page')
        }
      }
    }

    issueAccountCredential()
  }, [invitation, connectionActive])

  function openAdminLoginModal() {
    setAdminLoginError('')
    setShowAdminLoginModal(true)
  }

  function closeAdminLoginModal() {
    setShowAdminLoginModal(false)
    setAdminLoginError('')
  }

  function openAdminSettings() {
    if (adminAuthenticated) {
      setPageState('admin-settings')
    } else {
      openAdminLoginModal()
    }
  }

  function handleAdminLoginSubmit({ username, password }) {
    if (
      username === ADMIN_CREDENTIALS.username &&
      password === ADMIN_CREDENTIALS.password
    ) {
      setAdminAuthenticated(true)
      setShowAdminLoginModal(false)
      setAdminLoginError('')
      setPageState('admin-settings')
    } else {
      setAdminLoginError('Invalid admin credentials. Please try again.')
    }
  }

  function handleAdminLogout() {
    setAdminAuthenticated(false)
    setPageState('home')
  }

  async function handleRestrictionsToggle(isEnabled) {
    try {
      const response = await Axios({
        method: 'PATCH',
        url: `/api/admin/settings`,
        data: { enabled_restrictions: isEnabled },
      })
      if (response?.data?.config) {
        const updatedConfig = response.data.config
        setTripConfig(updatedConfig)
        syncSelectedTrip(updatedConfig)
      }
    } catch (error) {
      console.log('Error updating restriction settings:', error)
    }
  }

  async function handleTripSave({
    mode,
    tripId,
    tripData,
    backgroundImage,
    removeBackground,
    previousBackgroundPath,
  }) {
    try {
      const payload = { trip: tripData }

      if (backgroundImage) {
        payload.backgroundImage = backgroundImage
      }
      if (removeBackground) {
        payload.removeBackground = true
      }
      if (previousBackgroundPath) {
        payload.previousBackgroundPath = previousBackgroundPath
      }

      let response
      if (mode === 'create') {
        response = await Axios({
          method: 'POST',
          url: `/api/admin/trips`,
          data: payload,
        })
      } else {
        response = await Axios({
          method: 'PUT',
          url: `/api/admin/trips/${tripId}`,
          data: payload,
        })
      }

      const savedTrip = response?.data?.trip
      const updatedConfig = response?.data?.config

      if (updatedConfig) {
        setTripConfig(updatedConfig)
        syncSelectedTrip(updatedConfig, savedTrip)
      }

      return savedTrip
    } catch (error) {
      if (Axios.isAxiosError && Axios.isAxiosError(error)) {
        const status = error.response?.status
        const message =
          typeof error.response?.data?.message === 'string'
            ? error.response.data.message
            : ''

        if (status === 409) {
          alert(
            'A trip with that PNR already exists. Please enter a unique PNR.'
          )
        } else if (status === 400 && message.toLowerCase().includes('pnr')) {
          alert('Trip PNR is required. Please provide a PNR before saving.')
        } else if (message) {
          alert(message)
        } else {
          alert('Failed to save the trip. Please try again.')
        }
      } else {
        alert('Failed to save the trip. Please try again.')
      }
      console.log('Error saving trip:', error)
      return null
    }
  }

  async function handleTripDelete({ tripId, backgroundImagePath }) {
    try {
      const response = await Axios({
        method: 'DELETE',
        url: `/api/admin/trips/${tripId}`,
        data: { background_image: backgroundImagePath },
      })

      const updatedConfig = response?.data?.config
      if (updatedConfig) {
        setTripConfig(updatedConfig)
        syncSelectedTrip(updatedConfig)
      }
    } catch (error) {
      console.log('Error deleting trip:', error)
    }
  }

  const headerSharedProps = {
    setPageState,
    startNewAccount,
    invitation,
    connectionPurpose,
    setConnectionPurpose,
    loader,
    showLoginModal,
    setShowLoginModal,
    adminAuthenticated,
    openAdminLogin: openAdminLoginModal,
    openAdminSettings,
    refreshInvitation,
  }

  function startNewAccount() {
    setConnectionPurpose('new-account')
    setPageState('create-account-form')
  }

  /**
   * Request boarding pass verification workflow then populate digital passport data.
   * Sets loader state during long-polling API verification.
   * @param {object} tripData Selected trip record.
   */
  async function getBoardingPass(tripData) {
    const requireDTA = tripData.background_image.includes('frankfurt')
      ? true
      : false

    let workflow = ''

    const radioGroup = document.getElementsByName(tripData.pnr)
    let radioGroupValue = 0

    for (let i = 0; i < radioGroup.length; i++) {
      if (radioGroup[i].checked) {
        radioGroupValue = radioGroup[i].value
      }
    }

    if (radioGroupValue === '1') {
      workflow = 'digital_passport_seamless'
    } else {
      workflow = 'digital_passport_nonseamless'
    }

    console.log('Workflow:', workflow)

    setLoader(true)
    setSelectedTripData(tripData)
    try {
      const verRes = await Axios({
        method: 'POST',
        url: `/api/verifications`,
        data: {
          connection_id: invitation.connection_id,
          contact_id: invitation.contact_id,
          invitation_id: invitation.invitation_id,
          workflow: workflow,
          dta: requireDTA,
          destination_city: tripData.ticket_destination_city,
        },
        timeout: 1000 * 60 * 63,
        // signal: verController.signal,
      })
      const verificationRecords = verRes.data.verificationRecords

      console.log('Verification:', verRes)

      let holderImage = ''

      let verifiedAttributes = {}
      verificationRecords.forEach((record) => {
        record.result_data.forEach((attributes, index) => {
          verifiedAttributes[attributes.name] = attributes.value
        })
      })

      // (AmmonBurgi) If needed, format the base64 to be compatible with an html img element
      if (verifiedAttributes['Holder_Image']) {
        const imageParts = verifiedAttributes['Holder_Image'].split(',')
        if (imageParts[0] !== 'data:image/jpeg;base64') {
          holderImage =
            'data:image/jpeg;base64,' + verifiedAttributes['Holder_Image']
        } else {
          holderImage = verifiedAttributes['Holder_Image']
        }
      }

      // Now that we have the presentation, set the digitalPassportData and do some housekeeping
      setDigitalPassportData({
        given_names: verifiedAttributes['Given_Names'],
        family_name: verifiedAttributes['Family_Name'],
        holder_image: verifiedAttributes['Holder_Image']
          ? verifiedAttributes['Holder_Image']
          : '',
        holder_image_html: holderImage,
        date_of_birth: verifiedAttributes['Date_of_Birth'],
        gender: verifiedAttributes['Gender'],
        nationality: verifiedAttributes['Nationality'],
        dtc: verifiedAttributes['DTC'],
        document_number: verifiedAttributes['Document_Number'],
        document_type: verifiedAttributes['Document_Type'],
        issuing_authority: verifiedAttributes['Issuing_Authority'],
        issuing_state: verifiedAttributes['Issuing_State'],
        issue_date: verifiedAttributes['Issue_Date'],
        expiry_date: verifiedAttributes['Expiry_Date'],
      })

      setBoardingDenied(verRes.data.boarding_denied || false)

      setLoader(false)
      setPageState('boarding-pass-review')
    } catch (error) {
      setLoader(false)
      console.log('Error in getBoardingPass:', error)
    }
  }

  /**
   * Issue boarding pass credential using selected trip & verified passport attributes.
   * Navigates to success screen after delay.
   */
  async function downloadBoardingPass() {
    const credentialData = {
      frequent_flyer_number: userData.frequent_flyer_number,
      frequent_flyer_airline: selectedTripData.frequent_flyer_airline,
      frequent_flyer_status: selectedTripData.frequent_flyer_status,
      airline_alliance: selectedTripData.airline_alliance,

      passenger_given_names: digitalPassportData.given_names,
      passenger_family_names: digitalPassportData.family_name,
      passenger_image: digitalPassportData.holder_image,
      passenger_tsa_precheck: selectedTripData.passenger_tsa_precheck,
      pnr: selectedTripData.pnr,
      sequence_number: selectedTripData.sequence_number,
      ticket_origin: selectedTripData.ticket_origin,
      ticket_destination: selectedTripData.ticket_destination,
      ticket_operating_carrier: selectedTripData.ticket_operating_carrier,
      ticket_designated_carrier: selectedTripData.ticket_designated_carrier,
      ticket_flight_number: selectedTripData.ticket_flight_number,
      ticket_eticket_number: selectedTripData.ticket_eticket_number,
      ticket_seat_number: selectedTripData.ticket_seat_number,
      ticket_class: selectedTripData.ticket_class,
      ticket_exit_row: selectedTripData.ticket_exit_row,
      ticket_special_service_request:
        selectedTripData.ticket_special_service_request,
      ticket_with_infant: selectedTripData.ticket_with_infant,
      ticket_luggage: selectedTripData.ticket_luggage,

      boarding_secondary_screening:
        selectedTripData.boarding_secondary_screening,
      boarding_date_time: Math.round(
        DateTime.fromISO(selectedTripData.boarding_date_time).ts / 1000
      ).toString(),
      boarding_departure_date_time: Math.round(
        DateTime.fromISO(selectedTripData.boarding_departure_date_time).ts /
          1000
      ).toString(),
      boarding_arrival_date_time: Math.round(
        DateTime.fromISO(selectedTripData.boarding_arrival_date_time).ts / 1000
      ).toString(),
      boarding_gate: selectedTripData.boarding_gate,
      boarding_zone_group: selectedTripData.boarding_zone_group,

      standby_status: selectedTripData.standby_status,
      standby_priority: selectedTripData.standby_priority,
      standby_boarding_date: Math.round(
        DateTime.fromISO(selectedTripData.standby_boarding_date).ts / 1000
      ).toString(),
    }

    try {
      await Axios({
        method: 'POST',
        url: `/api/credentials/`,
        data: {
          invitation_id: invitation.invitation_id,
          contact_id: '',
          schemaName: 'Boarding_Pass',
          credentialData: credentialData,
        },
      })
      async function boardingPassSuccess() {
        await sleep(5000)
        setPageState('boarding-pass-success')
        setSelectedTripData()
      }
      boardingPassSuccess()
    } catch (error) {
      console.log('Error in downloadBoardingPass:', error)
      setPageState('error-page')
    }
  }

  const pageHomePage = (
    <Main banner="true">
      <Header
        {...headerSharedProps}
        backgroundColor="transparent"
        loggedIn={false}
      />
      <BannerText />
      <PlanAndBook />
      <Articles />
    </Main>
  )

  const pageCreateAccountForm = (
    <Main>
      <Header {...headerSharedProps} background="#2B3D2B" loggedIn={false} />
      <CreateAccountPage
        setPageState={setPageState}
        userData={userData}
        setUserData={setUserData}
        setLoader={setLoader}
      />
    </Main>
  )

  const pageCreateAccountIssue = (
    <Main>
      <Header {...headerSharedProps} loggedIn={false} />

      <div className="account-row">
        <QrCodeTitleText>WELCOME &nbsp;TO &nbsp;SITA &nbsp;AIR</QrCodeTitleText>
        <QrCodeSmallText>
          We now offer the ability to secure your account with a sign-in
          <br></br>
          credential stored in your SITA Air mobile app.
        </QrCodeSmallText>
        <QrCodeSmallText>
          You can use your credential to log in securely without a password.
        </QrCodeSmallText>
        <FormContainer>
          <FormWrapper>
            {!loader ? (
              <>
                <QrCodeInstructionsText>
                  Connect to receive a sign-in credential
                </QrCodeInstructionsText>
                <QR
                  value={invitation.invitation_url}
                  size={320}
                  renderAs="svg"
                />
                <QrCodeInstructionsSubText>
                  Scan the above QR code with your app to begin.
                </QrCodeInstructionsSubText>
                <QrCodeButton onClick={() => setPageState('account-dashboard')}>
                  Skip this step
                </QrCodeButton>
                <QrCodeButtonSubText>
                  You can receive a sign-in credential at any time
                </QrCodeButtonSubText>
              </>
            ) : (
              <div className="loader-wrapper">
                <div className="loader"></div>
                <h3 className="text-green text-bold">Please wait...</h3>
              </div>
            )}
          </FormWrapper>
        </FormContainer>
      </div>
    </Main>
  )

  const pageCreateAccountSuccess = (
    <SuccessPageContainer>
      <Header
        {...headerSharedProps}
        backgroundColor="rgba(43, 61, 43, 0.2)"
        loggedIn={true}
        userData={userData}
      />
      <SuccessContentCenter>
        <SuccessMainText>
          YOUR ACCOUNT HAS BEEN
          <br />
          CREATED SUCCESSFULLY
        </SuccessMainText>
        <SuccessRedirectingText>
          Redirecting you to your account dashboard...
        </SuccessRedirectingText>
      </SuccessContentCenter>
    </SuccessPageContainer>
  )

  // Auto-redirect after 3 seconds when on create-account-success page
  useEffect(() => {
    if (pageState === 'create-account-success') {
      const timer = setTimeout(() => {
        setPageState('account-dashboard')
      }, 3000)

      return () => clearTimeout(timer)
    }
  }, [pageState])

  const pageErrorLoggedOut = (
    <ErrorPageContainer>
      <Header
        {...headerSharedProps}
        backgroundColor="rgba(43, 61, 43, 0.2)"
        loggedIn={false}
      />
      <ErrorContentCenter>
        <ErrorMainText>SOMETHING WENT WRONG</ErrorMainText>
        <ErrorSubText>An error has occurred. Please try again.</ErrorSubText>
        <ErrorReturnButton onClick={() => setPageState('account-dashboard')}>
          Return to dashboard
        </ErrorReturnButton>
      </ErrorContentCenter>
    </ErrorPageContainer>
  )

  const pageAccountDashboard = (
    <Main>
      <Header
        {...headerSharedProps}
        pageState={pageState}
        loggedIn={true}
        userData={userData}
      />
      <DashboardWelcomeWrapper>
        <DashboardWelcomeContainer>
          <DashboardWelcomeLeftContainer>
            <DashboardWelcomeHeaderText>
              HI, {userData.given_names ? ' ' + userData.given_names : ''}
              {userData.family_names ? ' ' + userData.family_names : ''}
            </DashboardWelcomeHeaderText>
            <h3>
              {' '}
              {userData.account_established_date
                ? 'Joined on ' +
                  DateTime.fromSeconds(
                    parseInt(userData.account_established_date)
                  ).toFormat('MM/dd/yyyy')
                : 'Joined on ' +
                  DateTime.fromSeconds(
                    parseInt(Math.floor(Date.now() / 1000))
                  ).toFormat('MM/dd/yyyy')}
            </h3>
          </DashboardWelcomeLeftContainer>
          <DashboardWelcomeFlexContainer>
            <DashboardWelcomeMiddleContainer>
              <DashboardWelcomeLabelText>SITA AIR ID</DashboardWelcomeLabelText>
              <DashboardWelcomeValueText>
                {userData.accound_id
                  ? '#' + userData.accound_id
                  : 'Unregistered'}
              </DashboardWelcomeValueText>
              <DashboardWelcomeLabelText>
                SITA AIR MEMBER
              </DashboardWelcomeLabelText>
              <DashboardWelcomeValueText>
                VIEW PERKS <img src={iconArrowDown} alt="arrorw-down" />
              </DashboardWelcomeValueText>
            </DashboardWelcomeMiddleContainer>
            <DashboardWelcomeRightContainer>
              <DashboardWelcomeLabelText>MILES</DashboardWelcomeLabelText>
              <DashboardWelcomeValueText>150,000</DashboardWelcomeValueText>
            </DashboardWelcomeRightContainer>
          </DashboardWelcomeFlexContainer>
        </DashboardWelcomeContainer>
      </DashboardWelcomeWrapper>

      <DashboardContainer>
        <div className="left-nav-menu">
          <h2>
            SITA AIR ACCOUNT <Icon className="toggle-arrow" src={iconArrowUp} />
          </h2>
          <ul>
            <li>
              <a>Overview</a>
            </li>
            <li>
              <a>Activity</a>
            </li>
            <li>
              <a>Buy, Gift or Transfer Miles</a>
            </li>
            <li>
              <a>Program Information</a>
            </li>
          </ul>
          <div className="horizontal-line"></div>

          <h2>
            PREFERENCES <Icon className="toggle-arrow" src={iconArrowUp} />
          </h2>
          <ul>
            <li>
              <a>My Profile</a>
            </li>
            <li>
              <a>My Companions</a>
            </li>
            <li>
              <a>Contact Information</a>
            </li>
            <li>
              <a>Payment Methods</a>
            </li>
            <li>
              <a>Credits and Vouchers</a>
            </li>
          </ul>
          <div className="horizontal-line"></div>

          <h2>
            TRIPS <Icon className="toggle-arrow" src={iconArrowUp} />
          </h2>
          <ul>
            <li>
              <a>Manage Trips</a>
            </li>
            <li>
              <a>Saved Searches</a>
            </li>
          </ul>
          <div className="horizontal-line"></div>

          <h2>
            SETTINGS <Icon className="toggle-arrow" src={iconArrowDown} />
          </h2>
        </div>

        <div className="trips-dashboard">
          <h2 className="account-header">MANAGE TRIPS</h2>
          {(tripConfig?.trips || []).map((trip) => (
            <div key={trip.pnr}>
              {loader &&
              selectedTripData &&
              trip.pnr === selectedTripData.pnr ? (
                <TripsCard key={trip.pnr}>
                  <TripsImageContainer>
                    <Location backgroundImage={trip.background_image} />

                    <BackgroundGradient />

                    {trip.background_image.includes('frankfurt') ? (
                      <div className="visa-wrapper">
                        <IconVisa src={iconVisa} alt="" />
                        <span>Visa Required</span>
                      </div>
                    ) : null}
                    <p className="trips-code-entry bar-right-text">
                      {trip.ticket_destination}
                    </p>
                    <p className="trips-city-entry bar-text">
                      {trip.ticket_destination_city +
                        ', ' +
                        trip.ticket_destination_country}
                    </p>
                  </TripsImageContainer>
                  <TripsTextContainter>
                    <div className="loader-wrapper-dashboard">
                      <div className="loader-dashboard"></div>
                      <SpinnerText>Please wait...</SpinnerText>
                    </div>
                  </TripsTextContainter>
                </TripsCard>
              ) : (
                <TripsCard key={trip.pnr}>
                  <TripsImageContainer>
                    <Location backgroundImage={trip.background_image} />
                    <BackgroundGradient />
                    {trip.background_image.includes('frankfurt') ? (
                      <div className="visa-wrapper">
                        <IconVisa src={iconVisa} alt="" />
                        <span>Visa Required</span>
                      </div>
                    ) : null}
                    <p className="trips-code-entry bar-right-text">
                      {trip.ticket_destination}
                    </p>
                    <p className="trips-city-entry bar-text">
                      {trip.ticket_destination_city +
                        ', ' +
                        trip.ticket_destination_country}
                    </p>
                  </TripsImageContainer>
                  <TripsTextContainter>
                    <TripsRow1And2>
                      <TripItemWrapper>
                        <TripsLabelText>Date</TripsLabelText>
                        <TripsValueText>
                          {DateTime.fromISO(trip.boarding_date_time).toFormat(
                            'MMM dd'
                          )}
                        </TripsValueText>
                      </TripItemWrapper>

                      <TripItemWrapper>
                        <TripsLabelText>Boarding</TripsLabelText>
                        <TripsValueText>
                          {trip.boarding_date_time.split('T')[1]}
                        </TripsValueText>
                      </TripItemWrapper>

                      <TripItemWrapper>
                        <TripsLabelText>Seat</TripsLabelText>
                        <TripsValueText>
                          {trip.ticket_seat_number}
                        </TripsValueText>
                      </TripItemWrapper>
                      <TripItemWrapper>
                        <TripsLabelText>Flight</TripsLabelText>
                        <TripsValueText>
                          {trip.ticket_flight_number}
                        </TripsValueText>
                      </TripItemWrapper>

                      <TripItemWrapper>
                        <TripsLabelText>Departing</TripsLabelText>
                        <TripsValueText>
                          {trip.boarding_departure_date_time.split('T')[1]}
                        </TripsValueText>
                      </TripItemWrapper>

                      <TripItemWrapper>
                        <TripsLabelText>Class</TripsLabelText>
                        <TripsValueText>{trip.ticket_class}</TripsValueText>
                      </TripItemWrapper>
                    </TripsRow1And2>

                    <TripsRow3>
                      <BoardingPassButton onClick={() => getBoardingPass(trip)}>
                        Get Boarding Pass
                      </BoardingPassButton>
                      <EditButton>Edit Trip</EditButton>
                      <CancelTripButton>Cancel Trip</CancelTripButton>
                    </TripsRow3>
                    <TripsRow4>
                      <BoxedAvatarIcon
                        src={iconBoxedAvatar}
                        alt="Avatar Icon"
                      />
                      <SeamlessRadioContainer>
                        <SeamlessRadioInput
                          type="radio"
                          name={trip.pnr}
                          value="1"
                          defaultChecked
                        />
                        <SeamlessRadioInputCheckmark></SeamlessRadioInputCheckmark>
                        Seamless
                      </SeamlessRadioContainer>

                      <SeamlessRadioContainer>
                        <SeamlessRadioInput
                          type="radio"
                          name={trip.pnr}
                          value="0"
                        />
                        <SeamlessRadioInputCheckmark></SeamlessRadioInputCheckmark>
                        Not Seamless
                      </SeamlessRadioContainer>
                    </TripsRow4>
                  </TripsTextContainter>
                </TripsCard>
              )}
            </div>
          ))}
          <CircleButtonHelper>
            <CircledPlusIcon src={iconCirclePlus} />
          </CircleButtonHelper>
        </div>
      </DashboardContainer>
    </Main>
  )

  const pageAdminSettings = (
    <AdminPageWrapper>
      <Header {...headerSharedProps} loggedIn={false} />
      <AdminSettingsPage
        config={tripConfig}
        onToggleRestrictions={handleRestrictionsToggle}
        onSaveTrip={handleTripSave}
        onDeleteTrip={handleTripDelete}
        onLogout={handleAdminLogout}
      />
    </AdminPageWrapper>
  )

  const pageBoardingPassReview = (
    <Main>
      <Header {...headerSharedProps} loggedIn={true} userData={userData} />
      <div className="content-row">
        <BoardingPassReviewTitle>
          {boardingDenied ? <></> : 'YOUR BOARDING PASS IS READY.'}
        </BoardingPassReviewTitle>
        {boardingDenied && (
          <BoardingPassReviewSubtitle denied>
            Please proceed to the airport and speak with
            <br />a check-in agent for further assistance.
          </BoardingPassReviewSubtitle>
        )}
        {selectedTripData ? (
          boardingDenied ? (
            <div>
              <DownloadSuccessReturnButton
                onClick={() => {
                  setPageState('account-dashboard')
                  setSelectedTripData()
                }}
              >
                Return to Dashboard
              </DownloadSuccessReturnButton>
            </div>
          ) : (
            <>
              <BoardingPassCard>
                <div className="boarding-pass-logo-green"></div>
                {digitalPassportData.holder_image_html &&
                digitalPassportData.holder_image_html !== '' ? (
                  <img
                    className="passenger-image"
                    src={digitalPassportData.holder_image_html}
                    alt=""
                  />
                ) : (
                  <img
                    className="default-passenger-image"
                    src={DefaultUserImg}
                    alt=""
                  />
                )}
                <div className="divider-line"></div>
                <span className="pass-label gate">Gate</span>
                <span className="pass-data gate-text">
                  {selectedTripData.boarding_gate}
                </span>
                <span className="pass-label passenger">Passenger</span>
                <span className="pass-data passenger-text">
                  {digitalPassportData.given_names}{' '}
                  {digitalPassportData.family_name}
                </span>
                <span className="pass-label departure-city">
                  {selectedTripData.ticket_origin_city}
                </span>
                <span className="pass-data departure-city-code">
                  {selectedTripData.ticket_origin}
                </span>
                <div className="plane-green-icon"></div>
                <span className="pass-label arrival-city">
                  {selectedTripData.ticket_destination_city}
                </span>
                <span className="pass-data arrival-city-code">
                  {selectedTripData.ticket_destination}
                </span>
                <span className="pass-label departure-date">
                  Date of Departure
                </span>
                <span className="pass-data departure-date-text">
                  {DateTime.fromISO(
                    selectedTripData.boarding_departure_date_time
                  ).toFormat('MMM dd, yyyy')}
                </span>
                <span className="pass-label boarding-time">Boarding</span>
                <span className="pass-data boarding-time-text">
                  {selectedTripData.boarding_date_time.split('T')[1]}
                </span>
                <span className="pass-label departing-time">Departing</span>
                <span className="pass-data departing-time-text">
                  {selectedTripData.boarding_departure_date_time.split('T')[1]}
                </span>
                <span className="pass-label flight-number">Flight</span>
                <span className="pass-data flight-number-text">
                  {selectedTripData.ticket_flight_number}
                </span>
                <span className="pass-label seat-number">Seat</span>
                <span className="pass-data seat-number-text">
                  {selectedTripData.ticket_seat_number}
                </span>
                <span className="pass-label terminal">Terminal</span>
                <span className="pass-data terminal-text">
                  {selectedTripData.boarding_gate}
                </span>
                <span className="pass-label zone">Zone</span>
                <span className="pass-data zone-text">
                  {selectedTripData.boarding_zone_group}
                </span>
                <span className="pass-label status">Status</span>
                <span className="pass-data status-text">
                  {selectedTripData.frequent_flyer_status}
                </span>
              </BoardingPassCard>
              <DownloadButton onClick={() => downloadBoardingPass()}>
                Download Boarding Pass
              </DownloadButton>
            </>
          )
        ) : (
          ''
        )}
      </div>
    </Main>
  )

  const pageBoardingPassSuccess = (
    <DownloadSuccessPageContainer>
      <Header
        {...headerSharedProps}
        backgroundColor="rgba(43, 61, 43, 0.2)"
        loggedIn={true}
        userData={userData}
      />
      <DownloadSuccessContentCenter>
        <DownloadSuccessMainText>DOWNLOAD SUCCESSFUL</DownloadSuccessMainText>
        <DownloadSuccessSubText>
          Your boarding pass credential has been successfully issued to your
          mobile app. Thank you for using SITA Air.
        </DownloadSuccessSubText>
        <DownloadSuccessReturnButton
          onClick={() => setPageState('account-dashboard')}
        >
          Return to Dashboard
        </DownloadSuccessReturnButton>
      </DownloadSuccessContentCenter>
    </DownloadSuccessPageContainer>
  )

  return (
    <Frame id="app-frame">
      {pageState === 'home' ? pageHomePage : ''}
      {pageState === 'create-account-form' ? pageCreateAccountForm : ''}
      {pageState === 'create-account-issue' ? pageCreateAccountIssue : ''}
      {pageState === 'create-account-success' ? pageCreateAccountSuccess : ''}
      {pageState === 'error-page' ? pageErrorLoggedOut : ''}
      {pageState === 'account-dashboard' ? pageAccountDashboard : ''}
      {pageState === 'boarding-pass-review' ? pageBoardingPassReview : ''}
      {pageState === 'boarding-pass-success' ? pageBoardingPassSuccess : ''}
      {pageState === 'admin-settings' && adminAuthenticated
        ? pageAdminSettings
        : ''}
      <AdminLoginModal
        visible={showAdminLoginModal}
        onClose={closeAdminLoginModal}
        onSubmit={handleAdminLoginSubmit}
        errorMessage={adminLoginError}
      />
    </Frame>
  )
}

export default App
